import { ChitChatsPrinterApp } from "../src/chit_chats_printer_app/chit_chats_printer_app";
import { ChitChatsPrintService } from "../src/chit_chats_print_agent/chit_chats_print_agent_service";
import { ChitChatsPrintSetupPage } from "../src/chit_chats_print_agent/chit_chats_print_agent_setup_page";

window.ChitChatsPrinterApp = ChitChatsPrinterApp;
window.ChitChatsPrintService = ChitChatsPrintService;
window.ChitChatsPrintSetupPage = ChitChatsPrintSetupPage;
